module.exports = __webpack_public_path__ + "static/114-8c9b0957420966368ba3d0706a964bc6.png";